module.exports = __webpack_public_path__ + "static/media/icon-status-in-transit.0e6025de.svg";